import React from 'react'
import { DeleteOutlined, FormOutlined, SaveOutlined } from "@ant-design/icons";


export const CommentsContainer = ({ children, actionSaveEdit, actionDelete, isPutComment }) => {
    return (
        <div className='border-[1px] rounded border-[#E6E6E6] overflow-hidden'>
            {children}
            <div className='h-[30px] border-t-[1px] border-[#E6E6E6] grid grid-cols-2 divide-x-[1px]'>
                <div onClick={actionSaveEdit} className='flex justify-center items-center cursor-pointer'>
                    {isPutComment ? (
                        <div className={`w-4 `}>
                            <FormOutlined />

                        </div>
                    ) : (
                        <div className={`w-4`}>
                            <SaveOutlined />
                        </div>

                    )}
                </div>
                <div onClick={actionDelete} className='flex justify-center items-center cursor-pointer'>
                    <div className={`w-4`}>
                        <DeleteOutlined />
                    </div>
                </div>
            </div>
        </div>
    )
}
